// Engineer Scorecards — grid of per-engineer QaScorecard cards + the team snapshot
// passed to the AI coach. Ported from qa-live (QA-2286), dark-theme inline styles.

import { PULSE_COLORS } from './pulseConfig.js'
import QaScorecard from './QaScorecard.jsx'

function buildTeamSnapshot(roster) {
    const n = roster.length || 1
    const avg = (sel) => Math.round(roster.reduce((s, m) => s + sel(m), 0) / n)
    const leaderName = (sel) => [...roster].sort((a, b) => sel(b) - sel(a))[0]?.name.split(' ')[0] ?? '—'
    return {
        headcount: roster.length,
        avgScore: avg((m) => m.score),
        avgBugsCreated: avg((m) => m.bugsCreated),
        avgStoriesAutomated: avg((m) => m.storiesAutomated),
        avgAiCompletedTests: avg((m) => m.aiCompletedTests),
        automationContributors: roster.filter((m) => m.storiesAutomated > 0).length,
        aiContributors: roster.filter((m) => m.aiCompletedTests > 0).length,
        leaders: {
            Detection: leaderName((m) => m.bugsCreated),
            Automation: leaderName((m) => m.storiesAutomated),
            Resolution: leaderName((m) => m.qaStoriesClosed + m.bugsClosed),
        },
    }
}

export default function QaEngineerScorecards({ members, headerAction }) {
    const roster = members.filter((m) => m.qaTeam && m.score > 0).sort((a, b) => b.score - a.score)
    const team = buildTeamSnapshot(roster)

    return (
        <div
            style={{
                background: PULSE_COLORS.cardBg,
                borderRadius: '12px',
                padding: '20px',
                border: `1px solid ${PULSE_COLORS.border}`,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                }}
            >
                <div>
                    <h3 style={{ color: PULSE_COLORS.text, fontWeight: 600, fontSize: '16px', margin: 0 }}>
                        🧭 Engineer Scorecards
                    </h3>
                    <p style={{ marginTop: '2px', fontSize: '11px', color: PULSE_COLORS.textMuted }}>
                        Where each engineer spends their effort — and where they can grow
                    </p>
                </div>
                {headerAction}
            </div>

            {roster.length === 0 ? (
                <p style={{ fontSize: '13px', color: PULSE_COLORS.textMuted }}>
                    No QA activity in the selected window.
                </p>
            ) : (
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '16px',
                    }}
                >
                    {roster.map((m, idx) => (
                        <QaScorecard key={m.name} member={m} idx={idx} team={team} />
                    ))}
                </div>
            )}
        </div>
    )
}
